import React from 'react'
import { Alert } from 'react-bootstrap'
import EqxIcon from '../EqxIcon'

import './EqxAlert.css'

interface EqxAlertProps {
    variant?: string
    isChild?: boolean
    icon?: string
    children: React.ReactNode
}

const EqxAlert = (props: EqxAlertProps) => {
    return (
        <Alert variant={props.variant} className={props.isChild ? 'eqx-alert-child' : ''}>
            {props.icon && <EqxIcon fa={props.icon} className="me-2" />}
            {props.children}
        </Alert>
    )
}

export default EqxAlert
